import { NoId } from 'app/tools/general.types';

export enum UserRole {
  CONSUMER = 'user',
  REPAIRER = 'repairer',
}

export type UserAddress = Partial<{
  address1: string;
  address2: string;
  country: string;
  state: string;
  city: string;
  postcode: string;
}>;

export type DeliveryLocations = Partial<{
  addrLine1: string;
  addrLine2: string;
  country: string;
  id: number;
  city: string;
  postcode: string;
  userDisplayLocationName: string;
}>;

export type UserInfo = {
  id: number;
  firstName: string;
  lastName?: string;
  mobile?: string;
};

export type UserProfileImg = {
  profilePhoto?: string;
};

export type UserProfile = UserAddress & UserInfo & UserProfileImg;
export type UserProfileUpdateReq = UserAddress & NoId<UserInfo>;

export type SetProfileImgReq =
  | { profilePhoto: File }
  | { profilePhoto: null };

export type CompanyIdentity = {
  id: number;
  name: string;
  displayName: string;
  overview: string;
  website?: string;
  phone?: null;
  logo?: string;
  accountType?: string;
  rating?: number;
};

export type UserIdentity = {
  id: number;
  username: string;
  firstName: string;
  lastName?: string;
  email: string;
  enablePushNotification: boolean;
};

export type Identity = {
  user: UserIdentity;
  company?: CompanyIdentity;
  compProdCount: number;
  refCount: number;
  compEntryCount: number;
  isPartOfCompetition: boolean;
};

export type IdentityPlus = Identity & { locale?: string };

export type HistoryData = {
  productName: string;
  date: string;
  time: string;
  repairerName: string;
  amount: number;
  type: string;
  id: number;
  imageUrl: string;
  repairQuote: RepairQuote[];
  diagnosisQuote: DiagnosticsQuote[];
  repairCaseDescription: string;
};

export type RepairQuote = {
  quotationAmount: {
    amount: string;
    currency: string;
  };
};

export type DiagnosticsQuote = {
  quotationAmount: {
    amount: string;
    currency: string;
  };
};

export type RepairerInfo = {
  repairerName: string;
  imageUrl: string;
  address: string;
  rating: number;
  lat: string;
  long: string;
};
